<div class="min-h-screen bg-slate-50 text-slate-900">
  <div class="flex min-h-screen">
    <aside class="hidden w-72 shrink-0 lg:block">
      <div class="fixed inset-y-0 w-72">
        <app-sidebar />
      </div>
    </aside>

    @if (mobileMenuOpen()) {
      <div class="fixed inset-0 z-50 lg:hidden">
        <button
          type="button"
          class="absolute inset-0 bg-slate-950/50"
          aria-label="Close menu"
          (click)="closeMobileMenu()"
        ></button>

        <div class="absolute inset-y-0 left-0 w-72 shadow-2xl">
          <app-sidebar />
        </div>
      </div>
    }

    <div class="flex min-h-screen min-w-0 flex-1 flex-col">
      <app-topbar [pageTitle]="pageTitle()" [pageSubtitle]="pageSubtitle()" (menuClick)="openMobileMenu()" />

      <main class="flex-1 px-4 py-4 sm:px-6 sm:py-6">
        <router-outlet />
      </main>
    </div>
  </div>
</div>